export const OUTPUT_TAB_EN = {
  outputOption: 'Output Options',
  format: 'Format',
  style: 'Style',
  language: 'Language',
  customInstructions: 'Custom Instruction',
  clearSelection: 'Clear selection',
  formatTooltip: 'Formats',
  styleToolTip: 'Styles',
  languageToolTip: 'Languages',
  customInstructionsToolTip: 'Custom Instructions',
  inputForGeneration: 'Input for Generation',
  inputForGenerationTooltip:
    'Choose the text source for the next generation. "Source" uses your original input, "Draft" uses the previously generated output.',
  essentialTasks: 'Essential Tasks',
  customTaskPlaceholder: 'Custom task...'
}

export const OUTPUT_TAB_DE = {
  format: 'Task',
  style: 'Stil',
  language: 'Sprache',
  customInstructions: 'Extra Anweisungen',
  outputOption: 'Ausgabe Optionen',
  clearSelection: 'Auswahl löschen',
  formatTooltip: 'Tasks',
  styleToolTip: 'Stile',
  languageToolTip: 'Sprachen',
  customInstructionsToolTip: 'Extra Anweisungen',
  inputForGeneration: 'Eingabe für Generierung',
  inputForGenerationTooltip:
    'Wählen Sie die Textquelle für die nächste Generierung. "Quelle" verwendet Ihren ursprünglichen Text, "Entwurf" verwendet die zuvor generierte Ausgabe.',
  essentialTasks: 'Essential-Tasks',
  customTaskPlaceholder: 'Eigener Task...'
}
